// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import '@/css/theme/index.css'
import store from '@/vuex/store'
import require from '@/utils/require'
import axios from 'axios'
// import '@/utils/mock'
import './permission.js'
import 'babel-polyfill'
import '@/css/public.css'
import common from './utils/index'
import qs from 'qs';
// import uploader from 'vue-simple-uploader'
//Vue.prototype.$imgRoot = "http://square.alongplus.club";
Vue.prototype.$imgRoot = window.config.FILES_ROOT;
Vue.config.productionTip = false;
Vue.prototype.$axios = require;
Vue.prototype.waitTime = 1200;
Vue.prototype.$ajax = axios;
Vue.prototype.$qs = qs;
Vue.use(ElementUI);
Vue.use(common);
// Vue.use(uploader)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js